import { createI18n } from 'vue-i18n'
import { Converter } from 'opencc-js'

// 初始化繁簡轉換器
const converter = Converter({ from: 'cn', to: 'twp' }) // 從簡體轉換為繁體（台灣正體）

// 導入語言包
import zhCN from './zh-CN.js' // 簡體中文
import zhTW from './zh-TW.js' // 繁體中文

// 自動將簡體轉為繁體
function autoConvertToTraditional(messages) {
  const converted = {}
  
  // 遍歷所有消息鍵
  for (const key in messages) {
    if (typeof messages[key] === 'string') {
      // 字符串直接轉換
      converted[key] = converter(messages[key])
    } else if (typeof messages[key] === 'object') {
      // 遞歸處理對象
      converted[key] = autoConvertToTraditional(messages[key])
    } else {
      // 其他類型直接賦值
      converted[key] = messages[key]
    }
  }
  
  return converted
}

// 將所有簡體消息自動轉換為繁體
// 如果存在手動翻譯的繁體內容，則優先使用手動翻譯
const zhTWMessages = {
  ...autoConvertToTraditional(zhCN),
  ...zhTW // 手動翻譯的內容會覆蓋自動轉換的內容
}

const i18n = createI18n({
  legacy: true, // 使用傳統模式以確保在模板中正確顯示
  locale: 'zh-TW', // 默認語言為繁體中文
  fallbackLocale: 'zh-CN', // 後備語言為簡體中文
  messages: {
    'zh-CN': zhCN,
    'zh-TW': zhTWMessages
  },
  // 避免警告訊息
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

export default i18n 